import { render } from "./SingleConversation.vue?vue&type=template&id=0740f34a"
import script from "./SingleConversation.vue?vue&type=script&lang=js"
export * from "./SingleConversation.vue?vue&type=script&lang=js"
script.render = render

export default script